import(/* webpackMode: "eager", webpackExports: ["GlobalFooter"] */ "/app/src/components/global-footer/GlobalFooter.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalHeader"] */ "/app/src/components/global-header/GlobalHeader.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotFoundContents"] */ "/app/src/components/not-found-contents/NotFoundContents.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMEvent"] */ "/app/src/features/google-tag-manager/components/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteBanners"] */ "/app/src/features/site-banners/components/site-banners/SiteBanners.component.tsx");
